export { a as attr, b as belongsTo, M as default, h as hasMany } from "./has-many-d45aa09e";